import { TrackHistoryResponse } from 'services/FleetManagement/types'

export async function snapToRoads(_records: InputRecord[]): Promise<InputRecord[]> {
  const BATCH_SIZE = 100
  const updatedRecords: InputRecord[] = []

  const records = _records.filter((r) => !(r.latitude === 0 && r.longitude === 0))

  // Split the data into batches of 100
  const batches = []
  for (let i = 0; i < records.length; i += BATCH_SIZE) {
    batches.push(records.slice(i, i + BATCH_SIZE))
  }

  // Process each batch
  for (const batch of batches) {
    const path = batch.map((record) => `${record.latitude},${record.longitude}`).join('|')

    try {
      const response = await fetch(
        `${SNAP_TO_ROADS_API}?path=${encodeURIComponent(path)}&interpolate=false&key=${window.envVariables.REACT_APP_GOOGLE_SEARCH_API_KEY}`,
      )

      if (!response.ok) {
        console.error(`Failed to fetch Snap to Roads API: ${response.statusText}`)
        continue
      }

      const data = await response.json()
      const snappedPoints: SnappedPoint[] = data.snappedPoints || []

      // Update the original records with snapped lat/lon
      snappedPoints.forEach((snappedPoint) => {
        const originalIndex = snappedPoint.originalIndex
        const record = batch[originalIndex]
        record.latitude = snappedPoint.location.latitude
        record.longitude = snappedPoint.location.longitude
        updatedRecords.push(record)
      })
    } catch (error) {
      console.error('Error with Snap to Roads API:', error)
    }
  }

  // Maintain the original order of records
  const output = records.map((record) => {
    const updatedRecord = updatedRecords.find((updated) => updated.record_id === record.record_id)
    return updatedRecord || record // Fallback to original if not updated
  })

  return output
}

type InputRecord = TrackHistoryResponse['data'][0]

type SnappedPoint = {
  location: {
    latitude: number
    longitude: number
  }
  originalIndex: number
  placeId: string
}

const SNAP_TO_ROADS_API = 'https://roads.googleapis.com/v1/snapToRoads'
